import { render, staticRenderFns } from "./AuthNewPassword.vue?vue&type=template&id=f1f899fa"
import script from "./AuthNewPassword.vue?vue&type=script&lang=js"
export * from "./AuthNewPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports